export const actions = {
  /**
   * Fetch dataset Details from its UUID
   * @param { Object } ctx Vuex context
   * @param { String } UUID UUID of dataset
   * @param { Boolean } isEdit Checks if the API call for edit component
   */
  async getDatasetByUUID({ commit }, { UUID, isEdit }) {
    try {
      const currentDatasetDetails = await this.$axios.$get(`/api/dataset/${UUID}?isEdit=${isEdit}`);
      commit('setCurrentDatasetDetails', currentDatasetDetails);
    } catch (error) {
      this.$toast.error(this.$errorFromResponse('admin.dataset.commonData.APIerror', error));
    }
  },
  /**
   * Setting the dataset values to the store while changing application package values
   * @param { Object } ctx Vuex context
   * @param { Object } appPackageObj Application Package values to be updated
   */
  onChangeAppPackage({ commit }, appPackageObj) {
    //in case of clear input
    if (!appPackageObj.ApplicationPackageUUID) {
      commit('setCurrentDatasetFields', { ApplicationPackageUUID: null, ApplicationPackageFolderUUID: null });
    }

    //onchange of application package
    if (!!appPackageObj.ApplicationPackageUUID && !appPackageObj.ApplicationPackageFolderUUID) {
      commit('setCurrentDatasetFields', {
        ApplicationPackageUUID: appPackageObj.ApplicationPackageUUID,
        ApplicationPackageFolderUUID: null
      });
    }

    //onchange of application package folder
    if (appPackageObj.ApplicationPackageFolderUUID) {
      commit('setCurrentDatasetFields', {
        ApplicationPackageUUID: appPackageObj.ApplicationPackageUUID,
        ApplicationPackageFolderUUID: appPackageObj.ApplicationPackageFolderUUID
      });
    }
  },

  /**
   * Setting the dataset values to the store while changing dataset fields
   * @param { Object } ctx Vuex context
   * @param { Object } datasetValues Dataset values to be updated
   */
  onChangeDatasetValues({ commit }, datasetValues) {
    const resetValues = {
      AutoImportV3: false,
      AppendDataV3: false,
      TablePrefix: null
    };

    const data = { ...resetValues, ...datasetValues };
    commit('setCurrentDatasetFields', data);
  },

  async getList({ commit }, withV3Status = false) {
    commit('setDatasetListLoadingFlag', true);
    try {
      let datasetList = await this.$axios.$get(`/api/dataset?azureFunctionCheck=${withV3Status}`);
      if (withV3Status) {
        datasetList = datasetList.map((dataset) => ({
          ...dataset,
          datasetName: `${dataset.Name} | V3 : ${dataset.AzureFunctionEnable ? 'ON' : 'OFF'}`
        }));
      }
      commit('setDatasetList', datasetList);
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.fetch_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.dataset', 2)
          }),
          error
        )
      );
    }
    commit('setDatasetListLoadingFlag');
  }
};
